<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other'}" tag="li" class="breadcrumb-item">
						<a href="#">登入</a>
					</router-link>
				</ol>
			</nav>
			<div class="item-box">
				<div class="d-flex justify-content-center h-100">
					<div class="card form-box">
						<div class="card-header">
							<h3 class="item-title">登入</h3>
						</div>
						<div class="card-body">
							<form>
								<div class="input-group form-group">
									<div class="input-group-prepend">
										<span class="input-group-text">
											<i class="fas fa-user-alt"></i>
										</span>
									</div>
									<input type="text" class="form-control" placeholder="username" v-model="loginId">
								</div>
								<div class="input-group form-group">
									<div class="input-group-prepend">
										<span class="input-group-text"><i class="fas fa-key"></i></span>
									</div>
									<input type="password" class="form-control" placeholder="password" v-model="pasuwado">
								</div>
								<div class="form-group">
									<div class="alert alert-danger" role="alert" v-if="error != ''">
										{{error}}
									</div>
									<button type="button" class="pcbtn w-100" @click="login()">
										登入
									</button>
								</div>
							</form>
						</div>
						<div class="card-footer">
							<div class="d-flex justify-content-center links">
								還沒有帳號嗎?
								<router-link :to="{ name: 'Register'}" class="mx-3">
									註冊
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import CryptoJS from 'crypto-js'
	export default {
	name: 'Stand',
	data() {
		return {
			"loginId":"",
			"pasuwado": "",
			"error": "",
		}
	},
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '登入',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki'
	},
	methods: {
		login: function() {
			var self = this;
			if (self.loginId == "") {
				self.error = "請輸入帳號";
				return;
			}
			if (self.pasuwado == "") {
				self.error = "請輸入密碼";
				return;
			}
			//var url = "http://localhost/project/php/LoginMember.php";
			var url = "/static/php/LoginMember.php";
			var data = { "loginId": self.loginId, "pasuwado": self.pasuwado };
			$.ajax({
				type: "POST",
				url: url,
				data: data,
				success: function(data) {										
					var rsp = JSON.parse(data);
					if (rsp.Code == "1") {
						self.error = "找不到玩家";
					}else if (rsp.Code == "2") {
						self.error = "密碼錯誤";
					} else if (rsp.Code == "200") {						
						self.$store.dispatch("setUserStatus", data);
						self.$router.push("/");
					}
				},
				error: function(res) {
					this.error = res;
				}
			});
		},

	},
	created: function() {

	},
	computed: {

	},
	mounted: function() {

	}
}

</script>
<style type="text/css">
@import 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.11.2/css/all.min.css'

</style>
